<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'

import ScaleResource from '../../resources/scale'
import AgreementResource from '../../resources/agreement'
import JobTitleResource from '../../resources/jobTitle'
import UnionLocalResource from '../../resources/unionLocal'
import UnionJurisdictionResource from '../../resources/unionJurisdiction'
import ScheduleResource from '../../resources/schedule'
import GridAutocomplete from '../GridAutocomplete.vue'
import toastMixin from '../../mixins/toast'

export default Vue.extend({
    name: 'ScaleGrid',
    components: {
        AgGridVue,
    },
    mixins: [toastMixin],
    props: {
        rowData: {
            required: false,
            type: Array,
            default: () => {
                return []
            },
        },
    },
    data() {
        return {
            gridApi: undefined,
            columnApi: undefined,
            scaleColumnDefs: [
                {
                    field: 'id',
                    headerName: 'ID#',
                    minWidth: 40,
                    maxWidth: 70,
                    sortable: true,
                    valueSetter: () => null,
                    valueGetter: (params) => {
                        return params.data.id
                    },
                },
                {
                    field: 'agreement_id',
                    headerName: 'Agreement',
                    width: 100,
                    minWidth: 50,
                    maxWidth: 400,
                    sortable: true,
                    editable: true,
                    valueGetter: (params) => {
                        return params.data.get('agreement_id.name')
                    },
                    cellEditor: 'gridAutocomplete',
                    cellEditorParams: {
                        options: {
                            resourceClass: AgreementResource,
                            updateResource: true,
                        },
                    },
                },
                {
                    field: 'union_local_id',
                    headerName: 'Local',
                    width: 70,
                    minWidth: 40,
                    maxWidth: 120,
                    sortable: true,
                    editable: true,
                    valueGetter: (params) => {
                        return params.data.get('union_local_id.code')
                    },
                    cellEditor: 'gridAutocomplete',
                    cellEditorParams: {
                        options: {
                            resourceClass: UnionLocalResource,
                            updateResource: true,
                        },
                    },
                },
                {
                    field: 'job_title_id',
                    headerName: 'job_title',
                    minWidth: 150,
                    maxWidth: 300,
                    sortable: true,
                    editable: true,
                    valueGetter: (params) => {
                        return params.data.get('job_title_id.name')
                    },
                    cellEditor: 'gridAutocomplete',
                    cellEditorParams: {
                        options: {
                            resourceClass: JobTitleResource,
                            updateResource: true,
                        },
                    },
                },
                {
                    field: 'schedule_id',
                    headerName: 'Schedule',
                    width: 120,
                    minWidth: 80,
                    maxWidth: 300,
                    editable: true,
                    sortable: true,
                    valueGetter: (params) => params.data.get('schedule_id.name'),
                    cellEditor: 'gridAutocomplete',
                    cellEditorParams: {
                        options: {
                            resourceClass: ScheduleResource,
                            updateResource: true,
                        },
                    },
                },
                {
                    field: 'union_jurisdiction_id',
                    headerName: 'Jurisdiction',
                    width: 50,
                    minWidth: 50,
                    maxWidth: 200,
                    editable: true,
                    sortable: true,
                    valueGetter: (params) => params.data.get('union_jurisdiction_id.name'),
                    cellEditor: 'gridAutocomplete',
                    cellEditorParams: {
                        options: {
                            resourceClass: UnionJurisdictionResource,
                            updateResource: true,
                        },
                    },
                },
                {
                    field: 'scale',
                    headerName: 'Scale',
                    width: 90,
                    sortable: true,
                    editable: true,
                    cellClass: 'amount editable',
                    valueSetter: (params) => {
                        params.data.set('scale', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.get('scale')
                    },
                },
                {
                    field: 'scale_distant',
                    headerName: 'Scale (D)',
                    width: 90,
                    sortable: true,
                    editable: true,
                    cellClass: 'amount editable',
                    valueSetter: (params) => {
                        params.data.set('scale_distant', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.get('scale_distant')
                    },
                },
                {
                    field: 'scale_production_cities',
                    headerName: 'Scale(PC)',
                    width: 90,
                    sortable: true,
                    editable: true,
                    cellClass: 'amount editable',
                    valueSetter: (params) => {
                        params.data.set('scale_production_cities', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.get('scale_production_cities')
                    },
                },
                {
                    field: 'stn',
                    headerName: 'STN',
                    width: 50,
                    sortable: true,
                    editable: true,
                    cellClass: 'editable',
                    cellRenderer: (params) => {
                        let input = document.createElement('input')
                        input.type = 'checkbox'
                        input.checked = params.data.get('subject_to_negotiation') > 0 ? true : false
                        input.addEventListener('change', (event) => {
                            params.data.set('subject_to_negotiation', event.target.checked ? 1 : 0)
                        })
                        return input
                    },
                    valueGetter: (params) => {
                        return params.data.get('subject_to_negotiation')
                    },
                },
                {
                    field: 'fixed_scale',
                    headerName: 'Fixed Scale',
                    width: 90,
                    sortable: true,
                    editable: true,
                    cellClass: 'amount editable',
                    valueSetter: (params) => {
                        params.data.set('fixed_scale', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.get('fixed_scale')
                    },
                },
                {
                    field: 'date_start',
                    headerName: 'Start',
                    width: 80,
                    sortable: true,
                    editable: true,
                    cellClass: 'editable',
                    valueSetter: (params) => {
                        params.data.set('date_start', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.get('date_start')
                    },
                },
                {
                    field: 'date_end',
                    headerName: 'End',
                    width: 80,
                    sortable: true,
                    editable: true,
                    cellClass: 'editable',
                    valueSetter: (params) => {
                        params.data.set('date_end', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.get('date_end')
                    },
                },
                {
                    field: 'time_updated',
                    headerName: 'Updated',
                    width: 100,
                    sortable: true,
                    valueSetter: (params) => {},
                    valueGetter: (params) => {
                        return params.data.get('time_updated')
                    },
                },
                {
                    field: 'status',
                    headerName: 'Active',
                    width: 80,
                    editable: true,
                    sortable: true,
                    cellRenderer: (params) => {
                        let input = document.createElement('input')
                        input.type = 'checkbox'
                        input.checked = params.data.get('status') > 0 ? true : false
                        input.addEventListener('change', (event) => {
                            params.data.set('status', event.target.checked ? 1 : 0)
                        })
                        return input
                    },
                    valueGetter: (params) => {
                        return params.data.get('status')
                    },
                },
                {
                    field: 'agreement_id_ro',
                    headerName: 'Ag ID',
                    minWidth: 30,
                    maxWidth: 60,
                    sortable: true,
                    valueSetter: () => {},
                    valueGetter: (params) => params.data.attributes.agreement_id,
                },
                {
                    field: 'union_local_id_ro',
                    headerName: 'Loc ID',
                    minWidth: 30,
                    maxWidth: 60,
                    sortable: true,
                    valueSetter: () => {},
                    valueGetter: (params) => params.data.attributes.union_local_id,
                },
                {
                    field: 'job_title_id_ro',
                    headerName: 'Job ID',
                    minWidth: 30,
                    maxWidth: 60,
                    sortable: true,
                    valueSetter: () => {},
                    valueGetter: (params) => params.data.attributes.job_title_id,
                },
                {
                    field: 'schedule_id_ro',
                    headerName: 'Sch ID',
                    minWidth: 30,
                    maxWidth: 60,
                    sortable: true,
                    valueSetter: () => {},
                    valueGetter: (params) => params.data.attributes.schedule_id,
                },
                {
                    field: 'jurisdiction_id_ro',
                    headerName: 'Jurisd ID',
                    minWidth: 30,
                    maxWidth: 60,
                    sortable: true,
                    valueSetter: () => {},
                    valueGetter: (params) => params.data.attributes.union_jurisdiction_id,
                },
            ],
            scaleGridOptions: {
                enterMovesDown: true,
                enterMovesDownAfterEdit: true,
                defaultColDef: {
                    resizable: true,
                    // singleClickEdit: true,
                    // undoRedoCellEditing: true,
                    enterMovesDown: true,
                    enterMovesDownAfterEdit: true,
                },
                frameworkComponents: {
                    gridAutocomplete: GridAutocomplete,
                },
                onGridReady: (params) => {
                    if (params) {
                        this.gridApi = params.api
                        this.columnApi = params.columnApi
                    }
                },

                onFirstDataRendered: (params) => {
                    params.api.sizeColumnsToFit()
                },
            },
        }
    },
    computed: {
        resources() {
            return {
                ScaleResource,
                AgreementResource,
                UnionLocalResource,
                UnionJurisdictionResource,
                JobTitleResource,
                ScheduleResource,
            }
        },
    },
    methods: {
        selectScale(params) {
            if (params && params.data && params.data.attributes) this.$emit('select', params.data)
        },

        async saveGrid() {
            let changes = false
            if (!this.rowData || !this.rowData.length) {
                this.createToast('b-toaster-top-center', 'warning', true, 'Warning', 'No Data to Save')
                return false
            }

            this.rowData.forEach(async (row) => {
                if (row.changes && Object.keys(row.changes).length) {
                    changes = true
                    row.validate()
                    try {
                        await row.save()
                        row.changes = {}
                    } catch (error) {
                        // console.log(error)
                        this.createToast('b-toaster-top-center', 'danger', true, 'Save Error', error, true)
                        throw error
                    }
                }
            })

            if (!changes) this.createToast('b-toaster-top-center', 'warning', true, 'Warning', 'No Data to Save')
            else this.createToast('b-toaster-top-center', 'success', true, 'Success', 'Finished Save')
        },

        exportGrid() {
            this.gridApi.exportDataAsExcel()
        },
    },

    async created() {},
})
</script>

<template>
    <div>
        <div class="left"><h1>Scale Grid</h1></div>
        <div class="right">
            <b-button variant="outline-success" @click="exportGrid">Export</b-button>
            <b-button variant="primary" @click="saveGrid">Save</b-button>
        </div>
        <div class="clear"></div>
        <ag-grid-vue class="ag-theme-balham default-grid" :grid-options="scaleGridOptions" :column-defs="scaleColumnDefs" :row-data="rowData" @row-clicked="selectScale" />
        <div class="right">
            <b-button variant="outline-success" @click="exportGrid">Export</b-button>
            <b-button variant="primary" @click="saveGrid">Save</b-button>
        </div>
        <div class="clear"></div>
        <hr />
    </div>
</template>

<style>
@import '../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';

.default-grid {
    width: 100%;
    height: 200px;
}

.clear {
    clear: both;
}

.left {
    float: left;
}

.right {
    float: right;
}

.amount {
    text-align: right;
}

.editable {
    background-color: #3ea2ff15;
}
</style>
